/* eslint eqeqeq: 'off' */
import * as types from '../../action/actionTypes';
import * as url from '../../api/url';
import APIutil from '../../api/APIutils';
import {global_error_handling} from '../GlobalErrorMgmtAction';



//Get all discoveries requests in progress
export function GetBuildingsDiscovery() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_all_discovery_requests).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
              dispatch(actionToStoreSuccess(response,types.GET_DISCOVERY_LIST));
        }).catch(error => { throw error; })
    }
}


//Get all discoveries requests in progress
export function GetBuildingsDiscovered() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_all_discovered).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
                 dispatch(actionToStoreSuccess(response,types.GET_BUILDINGS_DISCOVERED_LIST));
        }).catch(error => { throw error; })
    }
}

export function GetBuildings(){
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_all_buildingslist).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
                dispatch(actionToStoreSuccess(response,types.GET_BUILDINGS_LIST));
        }).catch(error => { throw error; })
    }
}

//Add New buildings Installations
export function AddNewBuildings(data) { 
    return function (dispatch) {
        return APIutil.postData(url.get_all_discovery_requests,data).then(response => {
            dispatch(global_error_handling(response)); 
            dispatch(actionToStoreSuccess(response,types.ADD_NEW_BUILDINGS));
            // if(response.status != undefined && response.status == 200)
            //     dispatch(GetServerID(data.CustomerCode));
        }).catch(error => { throw error; })
    }
}


//Delete Method for DeleteFailedInstallations
export function DeleteFailedInstallations(Failed_buildings_to_be_deleted) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.get_all_discovery_requests,Failed_buildings_to_be_deleted).then(response => {
        dispatch(global_error_handling(response));        
        dispatch(GetBuildingsDiscovery());
        }).catch(error => {
            throw error;
        })
    }
}

//Delete Method for DeleteFailedInstallations
export function DeleteInstalledBuildings(Installed_buildings_to_be_deleted) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.delete_installed_buildings,Installed_buildings_to_be_deleted).then(response => {
        dispatch(global_error_handling(response));        
        dispatch(GetBuildingsDiscovered());
        }).catch(error => {
            throw error;
        })
    }
}

//Get License Server ID
export function SaveLicenseRequest(data) { 
    return function (dispatch) {
        return APIutil.postData(url.save_license_request,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != undefined && response.status != undefined && response.status == 200)
                dispatch(GetServerID(data.CustomerCode));
        }).catch(error => { throw error; })
    }
}

//Synchronized database
export function SynchronizedDatabase(data){
    return function(dispatch){
        return APIutil.postData(url.synchronize_database,data).then(response => {
            dispatch(global_error_handling(response));
            dispatch(actionToStoreSuccess(response,types.BUILDING_SYNCHRONIZATION));   
        }).catch(error => { throw error; })
    }
}

export function GetServerID(SerialNo){
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_server_id+SerialNo).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
              dispatch(actionToStoreSuccess(response,types.GET_SERVER_ID));
        }).catch(error => { throw error; })
    }
}

export function GetLicenseInformation(){
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_license_information).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
              dispatch(actionToStoreSuccess(response,types.GET_LICENSE_INFORMATION));
        }).catch(error => { throw error; })
    }
}

// export function GetFeatureLicense(){
//     return function (dispatch) {
//         return APIutil.getDataAPI(url.get_feature_license).then(response => {
//             dispatch(global_error_handling(response)); 
//             if(response != null && response != undefined)
//                 dispatch(actionToStoreSuccess(response,types.GET_FEATURE_LICENSE_INFORMATION));
//         }).catch(error => { throw error; })
//     }
// }

export function GetLicenseCustomerInformation(){
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_license_customer_information).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
                 dispatch(actionToStoreSuccess(response,types.GET_LICENSED_CUSTOMER_INFORMATION));
        }).catch(error => { throw error; })
    }
}

//Upload License File
export function UploadLicenseFile(SerialNumber,data) { 
    return function (dispatch) {
        return APIutil.postImage(url.upload_License_File+SerialNumber,data).then(response => {
           // dispatch(global_error_handling(response)); 
            if (response == undefined) {
                dispatch(actionToStoreSuccess(false, types.UPLOAD_STATUS));
            }
            else {
                if (response.statusText == "OK"){
                    dispatch(actionToStoreSuccess(true, types.UPLOAD_STATUS));
                }
                else{
                    dispatch(actionToStoreSuccess(false, types.UPLOAD_STATUS));
                    dispatch(actionToStoreSuccess(response.data, types.UPLOAD_LICENSE_FILE_RESPONSE))
                }
            }
        }).catch(error => { throw error; })
    }
}

//Getting Tenant and WorkOrder license information
export function GetTenantWorkOrderLicenseInfo(){
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_tenant_workorder_licenseinfo).then(response => {
          if(response != null && response != undefined)
            dispatch(actionToStoreSuccess(response,types.GET_TENANT_WORKORDER_LICENSE));
        }).catch(error => {throw error;})
    }
} 

//Getting User Role
export function GetUserRole(){
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_user_role).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
               dispatch(actionToStoreSuccess(response,types.GET_USER_ROLE));
        }).catch(error => { throw error; })
    }
}

export function SaveUserDetails(data) { 
    return function (dispatch) {
        return APIutil.postData(url.save_user_details,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status != undefined && response.status == 200)
                dispatch(GetUserList());
        }).catch(error => { throw error; })
    }
}

export function UpdateUserDetails(data) { 
    return function (dispatch) {
        return APIutil.editDataAPI(url.save_user_details,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status != undefined && response.status == 200)
                dispatch(GetUserList());
        }).catch(error => { throw error; })
    }
}

//Delete Method for deleting single or multiple holidays
export function DeleteTraneConnectUsers(users_to_be_deleted) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.save_user_details,users_to_be_deleted).then(response => {
        dispatch(global_error_handling(response));    
        if(response.status == 200)
               dispatch(GetUserList());
        }).catch(error => {
            throw error;
        })
    }
}

export function GetUserList(){
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_user_list).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined && response.length > 0)
                dispatch(actionToStoreSuccess(response,types.GET_USER_LIST));
        }).catch(error => { throw error; })
    }
}

export function GetUserDetails(UserId){
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_user_list+"/"+UserId).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)   
                dispatch(actionToStoreSuccess(response,types.GET_USER_DETAILS));
        }).catch(error => { throw error; })
    }
}


//Check Is UserName Exists
export function CheckIsUserNameExists(name) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_user_list + "/" + name).then(response => {
            dispatch(global_error_handling(response)); 
            var IsExists = false;
            if(response.userId != undefined && response.userId > 0)
            {
                IsExists = true;
            }
            dispatch(actionToStoreSuccess(IsExists,types.GET_IS_USERNAME_EXISTS));
        }).catch(error => { throw error; })
    }
}

export function GetUserChangeLogDetails(data) { 
    return function (dispatch) {
        return APIutil.postData(url.get_userchange_log,data).then(response => {
            dispatch(global_error_handling(response)); 
            if (response != null && response != undefined) 
                dispatch(actionToStoreSuccess(response, types.GET_USERCHANGELOGS_SUCCESSFULL));
        }).catch(error => { throw error; })
    }
}

export function GetApplicationVersion() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_application_version).then(response => {
          dispatch(global_error_handling(response));
          if(response.hasOwnProperty('status') !== true){
            if(response !== null && response !== undefined )
            dispatch(actionToStoreSuccess(response,types.GET_APPLICATION_VERSION));
          }
        }).catch(error => { 
            dispatch(global_error_handling(false));
            throw error; 
        })
    }
}

export function GetProductFullVersion(){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_product_fullversion).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PRODUCT_FULLVERSION));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetDbVersion(){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_db_version).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response,types.GET_DB_VERSION));
        }).catch(error => {
            throw error;
        })
    }
}

//Adding Trane Connect User
export function GetTraneUser(){
    return function (dispatch){
        return APIutil.getDataAPI(url.post_trane_user).then(response =>{
            dispatch(global_error_handling(response));
            if(response!==null && response!==undefined){
                dispatch(actionToStoreSuccess(response,types.GET_TRANE_USER));
            }
        }).catch(error => { throw error; })
    }
}
export function CreateTraneUser(data){
    return function (dispatch){
        return APIutil.postData(url.post_trane_user,data).then(response =>{
            dispatch(global_error_handling(response));
            if(response!==undefined && response!== null){
                dispatch(actionToStoreSuccess(response,types.TRANE_CONNECT_ERROR_STATUS));
                dispatch(GetTraneUser());
            }
        }).catch(error=>{throw error;})
    }
}
export function EditTraneUser(data){
    return function (dispatch){
        return APIutil.editDataAPI(url.put_trane_user,data).then(response => {
            dispatch(global_error_handling(response));
            if(response!==undefined && response!==null){
                dispatch(actionToStoreSuccess(response,types.TRANE_CONNECT_ERROR_STATUS));
                dispatch(GetTraneUser());
            }
        }).catch(error=>{throw error;})
    }
}

export function GetTraneSites(){
    return function (dispatch){
        return APIutil.getDataAPI(url.Site_User_Accounts).then(response =>{
            dispatch(global_error_handling(response));
            if(response!==null && response!==undefined){
                dispatch(actionToStoreSuccess(response,types.GET_TRANE_SITES));
            }
        }).catch(error => { throw error; })
    }
}

export function UpdateSCCredentials(data){
    return function (dispatch){
        return APIutil.postData(url.Site+data.siteId+'/userAccounts?siteId='+data.siteId,data).then(response =>{
            dispatch(global_error_handling(response));
            if(response!==undefined && response!== null){
                dispatch(actionToStoreSuccess(response,types.TRANE_CONNECT_ERROR_STATUS));
                dispatch(GetTraneSites());
            }
        }).catch(error=>{throw error;})
    }
}

//Client Side state management
export const SaveUserDetailsforclient = DataForState => ({
    type: types.SET_USER_DETAILS,
    Data: DataForState
});

export const ClearClientData = DataForState => ({
    type: types.CLEAR_USER_DETAILS,
    Data: DataForState
});

export function ResetError(){
    return function (dispatch) {
        dispatch(actionToStoreSuccess("", types.USER_ERRORRESET));
    }
}

export function ResetPassword(Data){
    return function (dispatch){
        dispatch(actionToStoreSuccess("", types.SET_RESET_PASSWORD_ERROR));
        return APIutil.postData(url.set_reset_password,Data).then(response =>{
            dispatch(global_error_handling(response));
            if(response !== undefined && response !== null && response.status === 200){
                if(response.data === "Password Validation Failed!")
                    dispatch(actionToStoreSuccess("PasswordUpdateFailed", types.SET_RESET_PASSWORD_ERROR));
                else if(response.data === "Email sending Failed!")
                    dispatch(actionToStoreSuccess("EmailFailed", types.SET_RESET_PASSWORD_ERROR));
                else
                    dispatch(actionToStoreSuccess("NoError", types.SET_RESET_PASSWORD_ERROR));
            }
        }).catch(error=>{throw error;})
    }
}

export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}